import React from "react";
import {Component} from "react";
import {Modal} from "antd";
import { injectIntl } from "react-intl";

export class DownloadModal extends Component {

    render() {
        const {
            loading,
            showDownloadModal,
            handleHiddenDownloadModal,
            intl
        } = this.props;

        return (
            <React.Fragment>
                <Modal
                    visible={showDownloadModal}
                    onCancel={handleHiddenDownloadModal}
                    footer={null}
                    scrollableBody={true}
                    style={{ 
                        top: 20,
                        maxWidth: "20%",
                    }}
                    destroyOnClose
                    confirmLoading={loading}
                    centered
                    closeIcon={null}
                >
                    <p
                        style= {{
                            textAlign: "center"
                        }}
                    >
                        {intl.formatMessage({id: "trash-assets-download"})}
                    </p>
                </Modal>
            </React.Fragment>
        )
    }
}

export default injectIntl(DownloadModal)